module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("19QKc"))).then(() => parcelRequire('hEqeo'));